import React from 'react';
import {
  Home as HomeIcon,
  RateReview as AuditIcon,
  Assessment as ReportsIcon,
} from '@mui/icons-material';
import { RoleBasedConfig } from './routeTypes';
import { UserRole } from '@features/authentication/types';
import { commonNavigationItems, commonRoutes } from './commonRoutes';
import { DashboardRoutes } from '@features/dashboard';
import { ReportsRoutes } from '@features/reports';
import { SurveyAuditRoutes } from '@features/survey-audit';
import { ProtectedRoute } from '../ProtectedRoute';
import { Navigate } from 'react-router-dom';

export const courseRepresentativeConfig: RoleBasedConfig = {
  navigation: {
    top: [
      {
        label: 'Dashboard',
        href: '/app/dashboard',
        icon: React.createElement(HomeIcon),
      },
      {
        label: 'Audit',
        href: '/app/survey-audits',
        icon: React.createElement(AuditIcon),
      },
      {
        label: 'Reports',
        href: '/app/reports',
        icon: React.createElement(ReportsIcon),
      },
    ],
    bottom: commonNavigationItems.bottom,
  },
  routes: [
    {
      path: 'dashboard',
      element: React.createElement(ProtectedRoute, null, React.createElement(DashboardRoutes)),
      protected: true,
      requiredRoles: [UserRole.COURSE_REPRESENTATIVE],
    },
    {
      path: '',
      element: React.createElement(Navigate, { to: 'dashboard', replace: true }),
    },
    {
      path: 'survey-audits/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(SurveyAuditRoutes)),
      protected: true,
      requiredRoles: [UserRole.COURSE_REPRESENTATIVE],
    },
    {
      path: 'reports/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(ReportsRoutes)),
      protected: true,
      requiredRoles: [UserRole.COURSE_REPRESENTATIVE],
    },
    ...commonRoutes,
  ],
};
